import {normalizeImgUrlToPreview} from "../../utils/Helper";

export function ArticleLeadImage({article}){

    var previewUrl=normalizeImgUrlToPreview(article.imgUrl);

    return (
        <section className="p-0">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="p-3 box-shadow-extra-large border-radius-4px bg-white text-center">
                        <h3 className="alt-font text-dark-gray fw-600 ls-minus-1px mb-15px">{article.title}</h3>
                        <br/>
                        <img src={previewUrl??"https://placehold.co/1190x750"} className="w-100 mb-7 border-radius-5px" alt=""/>
                        <div className="lg-20px sm-mb-0">
                            {article.author && (
                                <span>
                                    Szerző: <a className="text-dark-gray">{article.author}</a>
                                </span>
                            )}
                            {article.author && article.publishedAt && " • "}
                            {article.publishedAt && (
                                <span>
                                    Kelt: <a className="text-dark-gray">{article.publishedAt}</a>
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}